// We need a class to indicate where a filter checkbox has children

jQuery(".searchandfilter li").each(function () {

    if (jQuery(this).has(".children").length) {
        jQuery(this).addClass("sf-option-has-children");
    }

});


// Open category

jQuery(".searchandfilter .children").each(function () {
    if (jQuery(this).has(".sf-option-active").length) {
        parentCategory = jQuery(this).parent("li");
        jQuery(this).parent().addClass("sf-option-active");
    }

});


// Buttons for removing filter options

jQuery(".m-filter__buttons button").each(function () {

    jQuery(this).bind("click", function () {
        selector = ".m-filter__menu input[value='" + jQuery(this).attr("data-value") + "']";
        jQuery(selector).prop('checked', false).trigger('change');
    });

});


// External dropdown controls for Search & Filter Pro menu

jQuery(".m-dropdown-filter a").each(function () {

    jQuery(this).bind("click", function (e) {
        myfilter = "select[name='" + jQuery(this).closest(".m-dropdown").attr("data-filter") + "']";
        jQuery(myfilter).val(jQuery(this).attr("data-value")).trigger('change');
        e.preventDefault();
    });

});


// Dropdown controls for filtering Ajax Load More

jQuery(".m-dropdown-query a").each(function () {

    jQuery(this).bind("click", function (e) {
        myquery = "#" + jQuery(this).closest(".m-dropdown").attr("data-query");
        myvalue = jQuery(this).attr("data-value");
        jQuery(myquery).val(myvalue);
        jQuery(this).closest("form").submit();
        e.preventDefault();
    });

});


// Filter menu toggle (mobile)

jQuery(".m-filter__search-toggle").bind("click", function () {
    jQuery(this).closest(".m-filter__search-mobile").toggleClass("js-m-filter__search-mobile--isactive");
    jQuery(".m-filter__menu").toggleClass("js-m-filter__menu--isactive");

    if (jQuery(".m-filter__menu").hasClass("js-m-filter__menu--isactive")) {
        jQuery(".m-filter__menu-all a").focus();
    }

});


jQuery(".sf-field-taxonomy-catchup-categories label").on('click', function () {
    var $this = jQuery(this);
    $this.parent("li").toggleClass('sf-option-active');
    $this.closest('form').find('input[name="selected-category"]').val($this.prev().val());
    $this.closest("form").submit();
});
